import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

export function indexCommon(
	currentScript: HTMLElement | null | SVGScriptElement
) {
	const root = createRoot(document.createElement('div'));
	root.render(
		<React.StrictMode>
			<App currentScript={currentScript} />
		</React.StrictMode>
	);

	reportWebVitals();
}
